import DatePickerRange from 'components/PeriodSelection/DatePickerRange';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';


export function EditSongRecordingDetails(songSplitsDetail: any) {

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(4);

    return (
        <>
            <div className='ws-12'>
                <div className="alert alert-success ng-binding ng-hide" data-ng-show="showRecordingDetailsSuccessSaveMsg">Recording
                    Details
                    saved successfully
                </div>

                <div className="alert alert-danger ng-binding ng-hide">There was a problem submitting your request, one or more fields are missing or incorrect. </div>


                <div className="form-format ws-12 m0 ng-hide" data-ng-show="recordingDetailsDisplay">
                    <fieldset className="scheduler-border ws-6">
                        <legend className="scheduler-border"><h2 style={{ color: "#47529d" }} ><i className="fa fa-sticky-note-o"></i> Recording Details</h2></legend>
                        <div className="ws-12">
                            <div className="ws-6">
                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="releaseDuration">First Release
                                        Duration</label>
                                    <div className="label-entries">
                                        <input type="text" name="releaseDuration" placeholder="Release Duration" data-ng-model="recordingDetails.releaseDuration" />
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="CatlogNumber">First Release Catlog
                                        Number</label>
                                    <div className="label-entries">
                                        <input type="text" name="CatlogNumber" placeholder="CatlogNumber" data-ng-model="recordingDetails.catLogNumber" />
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="firstReleaseDate">First Release Date</label>
                                    <div className="label-entries">
                                        <input type="text" name="firstReleaseDate" placeholder="First Release Date" data-ng-model="recordingDetails.releaseDate" readOnly />
                                    </div>
                                </div>
                            </div>
                            <div className="ws-6">
                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="firstAlbumTitle">First Album Title</label>
                                    <div className="label-entries">
                                        <input type="text" name="firstAlbumTitle" placeholder="First Album Title" data-ng-model="recordingDetails.title" readOnly />
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="firstAlbumLabel">First Album Label</label>
                                    <div className="label-entries">
                                        <input type="text" name="firstAlbumLabel" placeholder="First Album Label" data-ng-model="recordingDetails.label" readOnly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="scheduler-border w-49 pull-right">
                        <legend className="scheduler-border"><h2 style={{ color: "#47529d;" }}><i className="fa fa-sticky-note-o"></i> Other Recording Details</h2></legend>
                        <div className="ws-12">
                            <div className="ws-5">
                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="ean">EAN</label>
                                    <div className="label-entries">
                                        <input type="text" name="ean" placeholder="EAN" data-ng-model="recordingDetails.eAN" />
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="ISRC">ISRC</label>
                                    <div className="label-entries">
                                        <input type="text" name="ISRC" placeholder="ISRC" data-ng-model="recordingDetails.iSRC" />
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="type">Media Type</label>
                                    <div className="label-entries">
                                        <select ng-model="recordingDetails.mediaType" name="mediaType" className="ng-pristine ng-untouched ng-valid">
                                            <option value="" className=""> Choose a Media Type</option>
                                            <option value="0" label="45 rpm 17 cm Single">45 rpm 17 cm Single</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="ws-7">
                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="intStdWorkCode">Recording Format</label>
                                    <div className="label-entries ws-12 mt">
                                        <div className="ws-5">
                                            <input type="radio" name="recordingFormat" value="A" placeholder="Recording Format" data-ng-model="recordingDetails.recordingFormat" />
                                            Audio
                                        </div>

                                        <div className="ws-5">
                                            <input type="radio" name="recordingFormat" value="V" placeholder="Recording Format" data-ng-model="recordingDetails.recordingFormat" />
                                            Video
                                        </div>
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label ng-binding" id="intStdWorkCode">Recording Technique</label>
                                    <div className="label-entries ws-12 mt">
                                        <div className="ws-4">
                                            <input type="radio" name="recordingTechnique" value="A" placeholder="Recording Technique" data-ng-model="recordingDetails.recordingTechnique" />
                                            Analogue
                                        </div>

                                        <div className="ws-4">
                                            <input type="radio" name="recordingTechnique" value="D" placeholder="Recording Technique" data-ng-model="recordingDetails.recordingTechnique" />
                                            Digital
                                        </div>

                                        <div className="ws-4">
                                            <input type="radio" name="recordingTechnique" value="U" placeholder="Recording Technique" data-ng-model="recordingDetails.recordingTechnique" />
                                            Unknown
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>

            </div >
        </>
    )

}